
const Prices = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Preise & Pakete</h1>
      <p>Wählen Sie das passende Modell für Ihre Anforderungen.</p>
    </div>
  );
};

export default Prices;
